<template>
  <el-container class="list_main_content">
    <el-aside width="200px" v-if="!$route.meta.single" v-show="asideShow">
      <p class="flow_tree_top_title">待办事项分类</p>
      <FlowTree
        ref="FlowTree"
        @currentTree="getCurrent"
        :loadCount="loadCount"
      ></FlowTree>
    </el-aside>
    <div
      class="navbar-collapse"
      :class="{ 'navbar-collapse-right': !asideShow }"
      :style="navbarCollapseStyle"
      @click="asideShow = !asideShow"
    >
      <div class="navbar-collapse-bg" style="display: none;">
        <i
          class="navbar-collapse-arrow"
          :class="{
            'el-icon-arrow-left': asideShow,
            'el-icon-arrow-right': !asideShow
          }"
        ></i>
      </div>
    </div>
    <el-container style="border-left:0px solid #E7EAEC;" :style="conheight">
      <collapse-search>
        <div class="content_top_wrap">
          <searchForm
            ref="searchForm"
            :options="searchOptions"
            :divide="3"
            @search="search('find')"
          />
          <el-row style="padding:8px 0px 8px 0px;">
            <el-col :span="24">
              <el-button size="small" type="primary" @click="search('find')"
                >查询</el-button
              >
              <el-button size="small" @click="reset" style="margin-left: 16px;">重置</el-button>
            </el-col>
          </el-row>
        </div>
      </collapse-search>
      <el-main class="form-content-wrap">
        <!-- default-sort 默认不排序（排序时查询待办很慢，用户可以点击某列进行排序） -->
        <el-table
          :data="rows"
          header-class-name="todo-header-row"
          row-class-name="todo-row"
          size="medium"
          height="100%"
          border
          v-loading.fullscreen.lock="fullscreenLoading"
          @selection-change="handleSelectionChange"
          v-if="defaultFiledShowConf"

        >
          <el-table-column type="selection" align="left" width="40">
           
          </el-table-column>

          <el-table-column
            prop="procInstId"
            :label="defaultFiledShowConf.procInstId.desc"
            v-if="defaultFiledShowConf.procInstId.frontShow"
            align="left"
          >
          </el-table-column>
          <el-table-column
            sortable
            prop="workOrderNo"
            :label="defaultFiledShowConf.workOrderNo.desc"
            v-if="defaultFiledShowConf.workOrderNo.frontShow"
            align="left"
            width="120"
          ></el-table-column>
          <el-table-column
            :label="defaultFiledShowConf.subject.desc"
            v-if="defaultFiledShowConf.subject.frontShow"
          >

          <!--show-overflow-tooltip 控制换行-->
            <template slot-scope="scope">
              <span
                :class="
                  history.includes(scope.row.id)
                    ? 'todo-subject-read'
                    : 'todo-subject'
                "
                @click="handleRowClick(scope.row)"
              >
                {{ scope.row.subject }}
              </span>
            </template>
          </el-table-column>
          <!-- <el-table-column
            :label="defaultFiledShowConf.procDefName.desc"
            v-if="defaultFiledShowConf.procDefName.frontShow"
            align="left"
            width="140"
          >
            <template slot-scope="scope">
              <span class="procDefName">{{ scope.row.procDefName }}</span>
            </template>
          </el-table-column> -->
          <el-table-column
            label="审批节点"
            v-if="defaultFiledShowConf.name.frontShow"
            align="left"
            width="150"
          >
            <template slot-scope="scope">
              <span class="taskName">{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="createTime"
            sortable
            :label="defaultFiledShowConf.createTime.desc"
            v-if="defaultFiledShowConf.createTime.frontShow"
            width="150"
            align="left"
          ></el-table-column> -->
          <el-table-column
            prop="creator"
            :label="defaultFiledShowConf.creator.desc"
            v-if="defaultFiledShowConf.creator.frontShow"
            align="left"
            width="120"
          ></el-table-column>
          <!-- <el-table-column
            prop="ownerName"
            :label="defaultFiledShowConf.ownerName.desc"
            v-if="defaultFiledShowConf.ownerName.frontShow"
            align="left"
            width="120"
          ></el-table-column> -->
          <!-- <el-table-column
            prop="assigneeName"
            :label="defaultFiledShowConf.assigneeName.desc"
            v-if="defaultFiledShowConf.assigneeName.frontShow"
            align="left"
          >
          </el-table-column> -->
          {{defaultFiledShowConf}}
          <el-table-column
            label="状态"
            v-if="defaultFiledShowConf.status.frontShow"
            align="left"
            width="100"
          >
            <template slot-scope="scope">

              
              <!-- <el-badge v-if="scope.row.status == 'NORMAL'" size="small" 
                >运行中</el-badge> -->
              <el-badge v-if="scope.row.status == 'TRANSFORMED'" size="small"
                >流转</el-badge
              >
              <el-badge v-if="scope.row.status == 'TRANSFORMEDINQU'" size="small"
                >征询</el-badge
              >
              <el-badge v-if="scope.row.status == 'DELIVERTO'" size="small"
                >转办</el-badge
              >
              <el-badge v-if="scope.row.status == 'FOLLOW'" size="small"
                >跟踪</el-badge
              >
              <el-badge v-if="scope.row.status == 'COMMU'" size="small"
                >沟通</el-badge
              >
              <el-badge v-if="scope.row.status == 'BACK'" is-dot class="item"></el-badge>

              <el-badge v-if="scope.row.status == 'BACK'" size="small"
                >驳回</el-badge
              >
              <el-badge v-if="scope.row.status == 'ADDSIGN'" size="small"
                >加签</el-badge
              >
              <el-badge v-if="scope.row.status == 'AGENT'" size="small"
                >委托</el-badge
              >
              <el-badge v-if="scope.row.status == 'SHARE'" size="small"
                >共享</el-badge
              >
              <el-badge v-if="scope.row.status == 'BACKSHARE'" size="small"
                >驳回共享</el-badge
              >
              <el-badge v-if="scope.row.status == 'APPROVELINEED'" size="small"
                >并行审批</el-badge
              >
              <el-badge v-if="scope.row.status == 'SIGNSEQUENCEED'" size="small"
                >顺序签署</el-badge
              >
              <el-badge v-if="scope.row.status == 'SIGNLINEED'" size="small"
                >并行签署</el-badge
              >
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            align="left"
            width="80"
          >
            <template slot-scope="scope">
              <a class="chuanyue" @click="taskToCopyTo()">传阅</a>
              <!-- <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                  <img src="/fvue/img/SmallDash.png">
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item class="clearfix">
                    <span @click="taskToDelegateClick()">转办</span>
                  </el-dropdown-item>
                  <el-dropdown-item class="clearfix">
                    <span @click="taskFollow()">跟踪</span>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown> -->


              
            </template>
          </el-table-column>
          <el-table-column
            prop="prop1"
            :label="defaultFiledShowConf.prop1.desc"
            v-if="defaultFiledShowConf.prop1.frontShow"
            align="left"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="prop2"
            :label="defaultFiledShowConf.prop2.desc"
            v-if="defaultFiledShowConf.prop2.frontShow"
            align="left"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="prop3"
            :label="defaultFiledShowConf.prop3.desc"
            v-if="defaultFiledShowConf.prop3.frontShow"
            align="left"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="prop4"
            :label="defaultFiledShowConf.prop4.desc"
            v-if="defaultFiledShowConf.prop4.frontShow"
            align="left"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="prop5"
            :label="defaultFiledShowConf.prop5.desc"
            v-if="defaultFiledShowConf.prop5.frontShow"
            align="left"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="prop6"
            :label="defaultFiledShowConf.prop6.desc"
            v-if="defaultFiledShowConf.prop6.frontShow"
            align="left"
            width="100"
          ></el-table-column>
        </el-table>     
      </el-main>
       <el-footer height="45px;line-height: 45px;">
        <el-row>
          <div style="display: initial;">
            <span style="padding-right:16px;font-size: 14px;font-family: PingFang SC-Regular, PingFang SC;font-weight: 400;color: #52535E;">已选 {{arrlen}}条</span>
            <el-button  size="small" @click="taskToCopyTo()">传阅</el-button>
          </div>
          <div style="float: right;display: initial;">
            <el-pagination
              class="pagination"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pagination.page"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pagination.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </el-row>
      </el-footer>

      <!-- 流程传阅-->
      <TaskToCopyTo ref="taskToCopyTo" :taskId="ids" />
      
    </el-container>
  </el-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import process from "@/api/process";
import FlowTree from "@/components/flow/flowTree.vue";
import utils from "@/utils.js";
import { Message } from "element-ui";
import TaskToCopyTo from "@/components/flow/task/taskToCopyTo.vue";
import eipOrgSelector from "@/components/eipControl/selector/EipOrgSelector.vue";
import searchForm from "@/components/common/searchForm.vue";
export default {
  name: "todo",
  components: {
    FlowTree,
    eipOrgSelector,
    TaskToCopyTo,
    searchForm
  },
  props: {
    defKey: {
      type: String,
      default: ""
    },
    orgName: { type: String, default: "" },
    orgId: { type: String, default: "" }
  },
  data() {
    return {
      // isExpand: false,
      form: { tableData: "", date: "", orgName: "", orgId: "" },
      conheight: { height: "" },
      asideShow: false,
      currentTree: "",
      fullscreenLoading: true,
      sorter: [],
      urgentStateConf: {},
      urgentStateConfList: [],
      urgentStateVal: "",
      ids: "", //待办任务id集合
      arrlen:0,
      defaultFiledShowConf: "",
      defaultFiledShowConfList: [
        { name: "subject", desc: "标题", frontShow: true },
        { name: "workOrderNo", desc: "工单号", frontShow: true},
        { name: "procInstId", desc: "流程编号", frontShow: true },
        { name: "procDefName", desc: "流程名称", frontShow: true},
        { name: "name", desc: "任务名称", frontShow: true },
        { name: "status", desc: "类型", frontShow: true },
        { name: "createTime", desc: "创建时间", frontShow: true },
        { name: "creator", desc: "创建人", frontShow: true },
        { name: "urgentStateValue", desc: "紧急状态", frontShow: true },
        { name: "dueExpDate", desc: "到期时间", frontShow: false },
        { name: "ownerName", desc: "所属人", frontShow: false },
        { name: "assigneeName", desc: "待审批人", frontShow: false },
        { name: "prop1", desc: "扩展1", frontShow: false },
        { name: "prop2", desc: "扩展2", frontShow: false },
        { name: "prop3", desc: "扩展3", frontShow: false },
        { name: "prop4", desc: "扩展4", frontShow: false },
        { name: "prop5", desc: "扩展5", frontShow: false },
        { name: "prop6", desc: "扩展6", frontShow: false }
      ],
      history: [],
      searchOptions: [
        {
          property: "bt.subject_",
          operation: "LIKE",
          type: "text",
          label: "流程标题",
          placeholder: "请输入流程标题"
        },
        {
          property: "inst.work_order_no",
          operation: "LIKE",
          type: "text",
          label: "工单号",
          placeholder: "请输入工单号"
        },
        {
          property: "bt.proc_def_name_",
          operation: "LIKE",
          type: "text",
          label: "流程名称",
          placeholder: "请输入流程名称"
        },
        {
          property: "bt.name_",
          operation: "LIKE",
          type: "text",
          label: "任务名称",
          placeholder: "请输入任务名称"
        },
        {
          property: "bt.create_time_",
          operation: "IN",
          type: "datetimerange",
          label: "创建时间"
        },
        {
          property: "inst.creator_",
          operation: "LIKE",
          type: "text",
          label: "创建人",
          placeholder: "请输入创建人"
        },
        {
          label: "状态",
          property: "bt.status_",
          operation: "EQUAL",
          type: "select",
          placeholder: "请选择状态",
          options: [
            { label: "待办", value: "NORMAL" },
            { label: "流转", value: "TRANSFORMED" },
            { label: "征询", value: "TRANSFORMEDINQU" },
            { label: "转办", value: "DELIVERTO" },
            { label: "跟踪", value: "FOLLOW" },
            { label: "沟通", value: "COMMU" },
            { label: "驳回", value: "BACK" },
            { label: "加签", value: "ADDSIGN" },
            { label: "委托", value: "AGENT" },
            { label: "共享", value: "SHARE" },
            { label: "驳回共享", value: "BACKSHARE" },
            { label: "并行审批", value: "APPROVELINEED" },
            { label: "顺序签署", value: "SIGNSEQUENCEED" },
            { label: "并行签署", value: "SIGNLINEED" }
          ]
        },
        {
          label: "发起组织",
          property: "inst.CREATE_ORG_ID_",
          placeholder: "请选择发起人组织",
          type: "orgSelector"
        }
      ]
    };
  },
  computed: mapState({
    navbarCollapseStyle: function() {
      if (this.asideShow) {
        return { left: "200px" };
      }
      return { left: "0px" };
    },
    rows: state => state.storeProcess.rows,
    pagination: state => state.storeProcess.pagination,
    total: state => state.storeProcess.total,
  }),
  watch: {
    "form.orgId": {
      handler(newName, oldName) {
        this.search("find");
      },
      immediate: true
    },
    rows: {
      handler(newVal, oldVal) {
        setTimeout(() => {
          //获取历史记录
          this.handleHistory();
        });
      },
      immediate: true
    }
  },
  methods: {
    //页面高度
    getHeight() {
      this.conheight.height = window.innerHeight - 112 + "px";
    },
    //流程传阅
    taskToCopyTo() {
      if (this.ids == "") {
        Message.warning("请选择要传阅的流程");
        return;
      }
      this.$refs.taskToCopyTo.handleClose(); //父组件调用子组件方法
    },
    //批量勾选待办流程获取
    handleSelectionChange(val) {
      this.ids = "";
      this.arrlen=0;//初始化
      if (val.length > 0) {
        for (let i = 0; i < val.length; i++) {
          this.ids = this.ids + val[i].id + ",";
          this.arrlen += 1;
        }
        this.ids = this.ids.substring(0, this.ids.length - 1);
      }
    },
    //Loading 加载中
    openFullScreen() {
      this.fullscreenLoading = true;
    },
    handleSizeChange: function(size) {
      //每页下拉显示数据
      this.$store.dispatch("storeProcess/setPaginationSize", size);
      this.search();
    },
    handleCurrentChange: function(currentPage) {
      //点击第几页
      this.$store.dispatch("storeProcess/setPaginationPageNum", currentPage);
      this.search();
    },
    //回车查询
    searchEnterFun: function(e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13) {
        this.search("find");
      }
    },
    // 处理排序
    handleSortChange: function(m) {
      this.sorter.splice(
        this.sorter.findIndex(s => s.property == m.prop),
        1
      );
      if (m.order) {
        this.sorter.push({
          property: m.prop,
          direction: m.order == "ascending" ? "ASC" : "DESC"
        });
      }
      this.search();
    },
    // 查询
    search(str) {
      if (str == "find") {
        this.$store.dispatch("storeProcess/setPaginationPageNum", 1);
      }
      let querys = [];
      if (this.$refs.searchForm) {
        querys = this.$refs.searchForm.getQuerys();
      }
      let queryFilter = {};
      if (this.currentTree) {
        querys.push({
          property: "bt.type_id_",
          value: this.currentTree,
          group: "typeId",
          operation: "IN",
          relation: "AND"
        });
      }
      if (this.defKey) {
        querys.push({
          property: "bt.proc_def_key_",
          value: this.defKey,
          operation: "EQUAL",
          relation: "AND"
        });
      }
      queryFilter = { pageBean: this.pagination, querys, sorter: this.sorter };
      this.openFullScreen();
      this.$store
        .dispatch("storeProcess/getTodoByPagination", queryFilter)
        .then(() => {
          this.fullscreenLoading = false;
        });
    },
    //重置
    reset() {
      this.$refs.searchForm.reset();
      this.search("find");
    },
    handleRowClick(row) {
      setTimeout(() => {
        utils.addRead(row.id, "todo");
      });
      let url = window.context.front;
      if (row.status == "SHARE" || row.status == "BACKSHARE") {
        if (row.identityList && row.identityList.length == 1) {
          //this.$router.push("/task/" + row.id + "/" + row.identityList[0].id);
          url = url + "/task/" + row.id + "/" + row.identityList[0].id;
        } else {
          let html =
            "<select ref=" +
            Math.random() +
            ' id="approvalLeaderSelect" style="width: 200px;height: 30px;border-radius: 4px;margin: 20px 70px;" ><option value="">请选择</option>';
          row.identityList.forEach(identity => {
            html +=
              '<option value="' +
              identity.id +
              '">' +
              identity.name +
              "</option>";
          });
          html += "</select>";
          let this_ = this;
          this.$alert(html, "请选择一个领导代为审批", {
            dangerouslyUseHTMLString: true,
            beforeClose: function(action, instance, done) {
              if (action == "confirm") {
                let se = document.getElementById("approvalLeaderSelect");
                if (se.selectedIndex == 0) {
                  this.$message.warning("请选择代为审批的领导");
                } else {
                  instance.close();
                  /*this_.$router.push(
                    "/task/" + row.id + "/" + se[se.selectedIndex].value
                  );*/
                  url =
                    url + "/task/" + row.id + "/" + se[se.selectedIndex].value;
                }
              } else {
                instance.close();
              }
            }
          });
        }
      } else if (
        row.status == "AGENT" &&
        row.ownerId != row.assigneeId &&
        row.ownerId == this.$store.state.login.currentUser.userId
      ) {
        //委托任务
        //this.$router.push("/instRead/" + row.procInstId + "/agent");
        url = url + "/instRead/" + row.procInstId + "/agent";
      } else if (row.status == "FOLLOW") {
        //跟踪任务
        //this.$router.push("/taskRead/" + row.id + "/FOLLOW");
        url = url + "/taskRead/" + row.id + "/FOLLOW";
      } else {
        //this.$router.push("/task/" + row.id + "/0");
        url = url + "/task/" + row.id + "/0";
      }
      let token = this.$store.state.login.currentUser.token;
      url = url + "?token=" + token;
      let winObjEI = window.open(
        url,
        "_blank",
        "width=" +
          (window.screen.availWidth - 10) +
          ",height=" +
          (window.screen.availHeight - 70)
      );
      let isClose = 1;
      let this_ = this;
      //关闭open页面时刷新父页面列表
      let loop = setInterval(function() {
        if (winObjEI.closed && isClose == 1) {
          isClose--;
          //这里写刷新代码
          this_.search("find");
          clearInterval(loop);
        }
      }, 1000);
    },
    //子组件传值父组件(待办分类查询)
    getCurrent(data) {
      if (data.id == 6) {
        this.openFullScreen();
        let pageBean = { pageBean: this.pagination };
        this.$store
          .dispatch("storeProcess/getTodoByPagination", pageBean)
          .then(() => {
            this.fullscreenLoading = false;
          });
      } else {
        let ids = [];
        this.getFlowTrees(data, ids);
        this.currentTree = ids.join(",");
        this.search("find");
      }
    },
    getFlowTrees(data, ids) {
      ids.push(data.id);
      let arr = data.children;
      for (var i = 0; i < arr.length; i++) {
        this.getFlowTrees(arr[i], ids);
      }
    },
    formatConfListToObj(tempList) {
      let editConfObj = {};
      tempList.forEach(c => {
        let key = c.name;
        editConfObj[key] = c;
      });
      this.$set(this, "defaultFiledShowConf", editConfObj);
    },
    loadCount() {
      return process.getCountByUserId(this.pagination);
    },
    getHistory(rowId, type) {
      return utils.hasRead(rowId, type);
    },
    handleHistory() {
      if (!this.rows || this.rows.length == 0) {
        return;
      }
      let ids = [];
      this.rows.forEach(item => {
        ids.push(item.id);
      });
      this.history = utils.getHistory(ids, "todo");
      this.$forceUpdate();
    }
  },
  created() {
    window.jQuery("#app").find("[name='app-base-main']").css("overflow-y","hidden");
    window.temp1 = this;
    window.addEventListener("resize", this.getHeight);
    this.getHeight();
    let this_ = this;
    this.$http
      .get(
        "${portal}/sys/sysProperties/v1/getDecryptByAlias?alias=taskListFiledConf"
      )
      .then(function(resp) {
        let tempConf = {};
        if (resp.data) {
          tempConf = JSON.parse(resp.data.value);
        } else {
          tempConf = this_.defaultFiledShowConfList;
        }
        this_.formatConfListToObj(tempConf);
      });

    let querys = [];
    if (this.defKey) {
      querys.push({
        property: "bt.proc_def_key_",
        value: this.defKey,
        operation: "EQUAL",
        relation: "AND"
      });
    }
    //判断是否有URL传参
    if (this.orgName && this.orgId) {
      this.form.orgName = this.orgName;
      this.form.orgId = this.orgId;
      querys.push({
        group: "orgId",
        property: "inst.CREATE_ORG_PATH_",
        value: this.orgId,
        operation: "LIKE",
        relation: "AND"
      });
    }
    let pageBean = {
      pageBean: { page: "1", pageSize: "20", showTotal: "true" },
      querys: querys
    }; //初次加载默认pageBean
    // this.$store
    //   .dispatch("storeProcess/getUrgentStateConf", { getConf: true })
    //   .then(data => {
    this.$store
      .dispatch("storeProcess/getTodoByPagination", pageBean)
      .then(() => {
        //页面加载调用tudo.js里面的分页方法
        this.fullscreenLoading = false;
      });
    // if (data.conf) {
    //   try {
    //     data.conf = JSON.parse(data.conf);
    //   } catch (error) {
    //     data.conf = eval("(" + data.conf + ")");
    //   }
    //   this.urgentStateConfList = data.conf;
    //   let conf = {};
    //   for (let index = 0, c; (c = data.conf[index++]); ) {
    //     if (c.default) {
    //       this.urgentStateConf.defaultValue = c.state;
    //     }
    //     conf[c.state] = c;
    //   }
    //   this.urgentStateConf.conf = conf;
    // }
    // });
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";

  /deep/ .el-badge__content.is-dot{
    margin-top: 10px !important;
    margin-right: 8px !important;
    width: 6px !important;
    height: 6px !important;
  }

/deep/ .search_form_label{
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #52535E;
}


/deep/ .el-footer{
  font-size: 14px !important;
  font-family: PingFang SC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #52535E !important;
  padding: 16px 0px !important;
  span,.el-pagination__total,.el-pagination__jump{
    font-size: 14px !important;
    font-family: PingFang SC-Regular, PingFang SC !important;
    font-weight: 400 !important;
    color: #52535E !important;
  }
  .el-pager li,.el-input__inner{
    height: 32px !important;
    font-size: 14px !important;
    font-family: PingFang SC-Regular, PingFang SC !important;
    font-weight: 400 !important;
    color: #52535E !important;
  }
  .el-pager .active{
    color: #1890FF !important;
  }
} 


/deep/ .el-table__body-wrapper{
  // height: 90% !important;
  overflow:auto;
}

/deep/ .el-badge{
  font-size: 14px !important;
  font-family: PingFang SC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #292B44 !important;
}

/deep/ .el-tabs__header{
  margin: 0px !important;
  padding-top: 8px;
}
/deep/ .navbar-collapse{
  display: none;
}

/deep/ .clearfix{
  font-size: 14px !important;
  font-family: PingFang SC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #1890FF !important;
}

/deep/ .chuanyue{
  font-size: 14px !important;
  font-family: PingFang SC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #1890FF !important;
  margin-right: 24px !important;
}

/deep/ .el-table::before{
  display: none;
}

.el-table--group::after, .el-table--border::after{
  display: none;
}

/deep/.el-table--border th{
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
  color: #292B44;
  background: #F0F2F5;
}


/deep/ .el-table{
  border: 0px !important;
  tr{
    max-height: 48px !important;
    height: 48px !important;
    line-height: 48px !important;
    td{
      padding: 0px !important;
      border-top: 0px solid #F0F2F5 !important;
      border-bottom: 1px solid #F0F2F5 !important;
      border-left: 0px solid #F0F2F5 !important;
      border-right: 0px solid #F0F2F5 !important;
    }
  }
  th{
    border: 0px;
  }
}


/deep/.el-table--border tr:hover > td{
    background-color:#EDF6FB !important;
    .todo-subject{
      color: #1890FF !important;
    }
    .todo-subject-read{
      color: #1890FF !important;
    }
    // .taskName{
    //   color: #1890FF !important;
    // }
}

// /deep/.el-table--border tr {
//   border-top: 0px solid #F0F2F5;
//   border-bottom: 1px solid #F0F2F5;
//   border-left: 0px solid #F0F2F5;
//   border-right: 0px solid #F0F2F5;
// }



//x3样式 隔行变色
/*
/deep/.el-table--border tr:nth-child(even){
    background: rgb(240, 241, 241);
}

/deep/.el-table--border th,
/deep/.el-table--border td {
  border-bottom: 1px solid rgb(218, 218, 218);
  border-right: 1px dashed rgb(218, 218, 218);
}

/deep/.el-table--border tr:hover > td{
    background-color:#fdfdaf !important;
}

/deep/.el-table--border th,
/deep/.el-table--border td {
  border-bottom: 0px solid #F0F2F5;
  border-right: 0px dashed rgb(218, 218, 218);
}

*/
.list_main_content {
  padding: 0;
}

/deep/.el-table .cell {
  padding-left: 16px;
  padding-right: 0px;
  // line-height: unset;
  font-size: 14px !important;
  font-family: PingFang SC-Regular, PingFang SC !important;
  font-weight: 400 !important;
  color: #292B44 !important;
  span{
    font-size: 14px !important;
    font-family: PingFang SC-Regular, PingFang SC !important;
    font-weight: 400 !important;
    color: #292B44 !important;
  }
}
/deep/ .todo-subject-read,
/deep/.todo-subject,
/deep/.el-tooltip > span {
  font-size: 14px !important;
}




/deep/.el-table--medium th,
/deep/ .el-table--medium td {
  padding: 1px 0;
}

.el-container {
  background-color: #fff;
  padding: 0px !important;
}
.el-row {
  margin-bottom: 10px;
}

.el-header {
  border-bottom: 0px solid #ededed;
}

.todo-subject,
.todo-subject-read {
  cursor: pointer;
}

.todo-subject {
  color: $--theme-color;
}

.top-title {
  line-height: 58px;
  margin-left: 20px;
  font-size: 16px;
  color: #a2a2a2;
}

/deep/.el-button {
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 8px;
  padding-top: 8px;
}

/deep/.el-tree {
  position: relative;
  cursor: default;
  background: #fff;
  color: $--color-text-primary;
  font-size: 13px;
}
.form-content-wrap {
  // max-height:60% !important;
  padding: 0px !important;
  // 隐藏滚动条
  &::-webkit-scrollbar {
    width: 0;
    background-color: transparent;
  }
  /*火狐下隐藏滚动条*/
  scrollbar-width: none;
}
.content_top_wrap {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 0px 0px 8px 0px;
  &_form {
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
    /deep/ .el-input__prefix,
    /deep/.el-input__suffix {
      height: 32px;
    }
    .form_input {
      margin-right: 10px;
    }
    .form_date_picker,
    .form_org_selector {
      margin-right: 10px;
      min-width: 300px;
    }
  }
}
</style>
